module.exports = __webpack_public_path__ + "assets/images/pedra_menos_629e7dde42266a3aa3f89b262904f627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-montanha/pedra_menos.png
// module id = 169
// module chunks = 0